import iconInvoices from 'condolivre-ds/build/static/icon/icon_sm_fornecedores.svg';
import {
    Roles,
    CONSIGNADO,
    LOAN_ORDER,
    LOAN_CONCILIATIONS,
    LOAN_EMPLOYEES,
    LOAN_BANKSLIP
} from '@/config/constants';
import {
    ROUTE_INVOICES,
    ROUTE_LOAN,
    ROUTE_DASHBOARD,
    ROUTE_CONCILIATIONS,
    ROUTE_BANKSLIP,
    ROUTE_EMPLOYEES
} from '@/config/routes';

export const MENU = [
    {
        label: 'Dashboard',
        path: ROUTE_DASHBOARD,
        id: 'dashboard',
        icon: '/images/icon_sm_dash.svg',
        iconDark: '/images/icon_sm_dash_dark.svg',
        roles: null
    },
    {
        label: CONSIGNADO,
        icon: '/images/icon_sm_consignado.svg',
        iconDark: '/images/icon_sm_consignado_dark.svg',
        path: '/loan',
        id: 'loan',
        roles: [Roles.ADMIN, Roles.RH, Roles.RH_ADM, Roles.RH_CONDO, Roles.RESCISSION],
        items: [
            { label: 'Controle de empréstimos', path: ROUTE_LOAN, id: LOAN_ORDER },
            { label: 'Colaboradores', path: ROUTE_EMPLOYEES, id: LOAN_EMPLOYEES },
            { label: 'Boletos', path: ROUTE_BANKSLIP, id: LOAN_BANKSLIP },
            { label: 'Conciliação bancária', path: ROUTE_CONCILIATIONS, id: LOAN_CONCILIATIONS }
        ]
    },
    {
        label: 'Fornecedores',
        icon: iconInvoices.src,
        iconDark: '/images/icon_sm_dash_dark.svg',
        path: '/supply',
        id: 'supply',
        roles: [Roles.ADMIN, Roles.SUPPLY],
        items: [{ label: 'Meus títulos', path: ROUTE_INVOICES, id: 'supply-invoice' }]
    },
    {
        label: 'CondoIndica',
        icon: '/images/icon_sm_condoindica.svg',
        iconDark: '/images/icon_sm_condoindica_dark.svg',
        path: '/suppliers',
        id: 'suppliers',
        roles: null
    },
    {
        label: 'Simulador Empréstimo Condomínio',
        path: '/company-loan-simulator',
        id: 'company-loan-simulator',
        icon: '/images/icon_sm_condominios.svg',
        iconDark: '/images/icon_sm_condominios_dark.svg',
        roles: null
    }
];

const filterMenuItems = (menu, roles) => {
    if (roles.length === 1) {
        if (roles.includes(Roles.RESCISSION) && menu.label === CONSIGNADO) {
            menu.items = menu.items?.filter(
                (item) => ![LOAN_ORDER, LOAN_CONCILIATIONS].includes(item.id)
            );
        }
        if (
            [Roles.RH, Roles.RH_CONDO, Roles.RH_ADM].includes(roles[0]) &&
            menu.label === CONSIGNADO
        ) {
            menu.items = menu.items?.filter((item) => ![LOAN_EMPLOYEES].includes(item.id));
        }
    }
    return menu;
};

export const filterMenus = (roles: string[]) => {
    const filteredMenu = MENU.map((menu) => filterMenuItems(menu, roles));

    return filteredMenu.filter((menu) => {
        return menu.roles == null || menu.roles?.some((r) => roles.includes(r));
    });
};
